var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 33,
    width: 33,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Twitter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-3{fill:#28414b;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33a16 16 0 1116-16 16 16 0 01-16 16z",
    fill: "#ffc212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2 11.19a7.44 7.44 0 01-1.87.54c.3-.05.75-.6.93-.82a3.51 3.51 0 00.62-1.14v-.09a.11.11 0 00-.1 0 9.9 9.9 0 01-2.23.86.14.14 0 01-.15 0 1.75 1.75 0 00-.2-.19 3.87 3.87 0 00-1.08-.66 3.59 3.59 0 00-1.65-.27 3.93 3.93 0 00-1.57.44 4.08 4.08 0 00-1.26 1 3.92 3.92 0 00-.76 1.51 4.1 4.1 0 000 1.6c0 .09 0 .1-.08.09a11.87 11.87 0 01-7.64-3.9c-.09-.1-.14-.1-.21 0a3.87 3.87 0 00.66 4.58 4.69 4.69 0 00.47.42 3.94 3.94 0 01-1.48-.42c-.09-.05-.13 0-.14.08a2.2 2.2 0 000 .44 4 4 0 002.42 3.13 2.54 2.54 0 00.49.15 4.46 4.46 0 01-1.45 0c-.1 0-.14 0-.1.13a4 4 0 003 2.55 2.9 2.9 0 01.41.06 4.81 4.81 0 01-2.08 1.1 7.49 7.49 0 01-3.15.47h-.25c-.04 0 0 .07 0 .11q.33.21.66.39a10.1 10.1 0 002.11.84 11.21 11.21 0 0010.9-2.55 11.41 11.41 0 003-8.34c0-.12.14-.19.23-.25a7.21 7.21 0 001.47-1.55.41.41 0 00.09-.29s.07-.05-.01-.02z",
    fill: "#28414b"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M13.86 24.59s.33 0 0 0c0-.02.04 0 0 0zM20.42 9.38a.06.06 0 01-.08 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterIcon);
export default __webpack_public_path__ + "static/media/twitter_icon.309f02866afab016cbfbc68b70aac550.svg";
export { ForwardRef as ReactComponent };